import { apiService, validateAndAssert } from '@app/services/api-service';
import { DashboardOutDtoSchema } from './dashboard.schema';

export abstract class DashboardApi {
  static async getMyStats() {
    return validateAndAssert(apiService.get('/private/dashboard/my-stats'), DashboardOutDtoSchema);
  }
}
